export default __webpack_public_path__ + "static/media/addIconCircle.f93c1dd5.svg";